import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { scrollToTop } from "utils/scrollToTop";

const ScrollToTop = () => {
  const history = useHistory();

  useEffect(() => {
    scrollToTop();
  }, [history.location.pathname]);

  return null;
};

export default ScrollToTop;
